export default "__VITE_ASSET__BLxLNDfz__"